// biome-ignore lint/style/useFilenamingConvention: TanStack Router uses $param convention for dynamic routes
import { createRoute } from '@tanstack/react-router';
import { AccessGuard } from '@/components/guards/access-guard';
import { AuthGuard } from '@/components/guards/auth-guard';
import { PurchaseOrderPage } from '@/pages/purchase-orders/purchase-order-page';
import { Route as RootRoute } from './__root';

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: 'purchase-orders/$id',
  component: () => (
    <AuthGuard>
      <AccessGuard>
        <PurchaseOrderPage />
      </AccessGuard>
    </AuthGuard>
  ),
  staticData: {
    titleKey: 'PurchaseOrders',
  },
});
